import { css } from '@emotion/css'
import { colors, fontWeight, spacing, fontFamily } from '@offerzen/pinata'

const styles = {
  wrapper: css({
    fontFamily: fontFamily.body,
    marginBottom: 0,
  }),

  heading: css({
    marginBottom: spacing.medium,
    color: colors.blackPearl,
    fontWeight: fontWeight.medium,
  }),
  countrySubheading: css({
    marginBottom: 0,
  }),
  field: css({
    div: {
      input: {
        height: 38,
        border: 'none',
      },
    },
    width: '100%',
    outline: 'none',
    marginBottom: spacing.medium,
  }),
}

export default styles
